import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CandidateJourney } from './candidate-journey.interface';
import { JourneyService } from './candidate-journey.service';

const service = new JourneyService();

export interface JourneyState {
   journeysOverview?: ApiResource<Array<CandidateJourney>>;
}

const JourneyStore: Module<JourneyState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getJourneys(context, payload: { candidateId: number; query: LocationQuery }) {
         const response = await service.getJourneys(payload.candidateId, payload.query);
         return response;
      },
      async getJourney(context, payload: { candidateId: number; journeyId: number; query: LocationQuery }) {
         const response = await service.getJourney(payload.candidateId, payload.journeyId, payload.query);
         return response;
      },
   },
};

export default JourneyStore;
